package org.ecolution.webpage.data

data class KeyFact(
    val imgSrcLightMode: String,
    val imgSrcDarkMode: String,
    val title: String,
    val description: String
)
